import { useDeleteCollectionMutation } from '@sketch/gql-types'

import { removeCollectionFromProject } from './utils/collection.cache'

interface UseDeleteCollectionProps {
  projectIdentifier: string
  onCompleted?: () => void
}

export const useDeleteCollection = ({
  projectIdentifier,
  onCompleted,
}: UseDeleteCollectionProps) => {
  const [mutation] = useDeleteCollectionMutation({
    onError: 'show-toast',
    onCompleted,
    update: (cache, { data }) => {
      if (!data) {
        return
      }

      const collectionIdentifier = data.deleteCollection.collection.identifier

      removeCollectionFromProject({
        cache,
        projectIdentifier,
        collectionIdentifier,
      })
    },
  })

  return mutation
}
